// extracted by mini-css-extract-plugin
module.exports = {"mobileMenu":"MobileNavMenu-module--mobileMenu--B_2xF","active":"MobileNavMenu-module--active--nMrCm"};